import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      {/* Header */}
      <div className="mb-10 md:mb-14">
        <span className="text-xs md:text-sm text-foreground-400 font-medium tracking-wide uppercase">
          Categorias
        </span>
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-semibold text-foreground-900 mt-2 leading-tight">
          Explore Nossas{' '}
          <span className="italic font-normal text-primary-500" style={{ fontFamily: 'Caveat, cursive' }}>
            Categorias de Produtos
          </span>
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl">
          Navegue por categorias organizadas e encontre exatamente o que procura com links verificados e atualizados diariamente.
        </p>
      </div>

      {/* Category Image Cards Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.name}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200 cursor-pointer transition-all hover:-translate-y-1"
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={cat.image}
                alt={`HoobuySpreadsheet ${cat.name}`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-3 md:p-3.5">
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <div className="flex items-center gap-1 mt-1 text-xs text-foreground-400">
                <span>Ver produtos</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}